import React, { Component } from "react";
import { Select, Form, Input } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Dropdown } from "../../../../components/common/dropdown";

const { Option } = Select;

const children = [
  { id: 1, name: "Admin" },
  { id: 2, name: "Sale" },
];

export class AccountId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [
        { id: 1, code: 1, name: "Admin" },
        { id: 2, code: 2, name: "Sale" },
      ],
    };
  }

  handleChange(value) {}

  setRole = (data) => {
    const { onChangeForm } = this.props;
    onChangeForm("roles", data.code);
  };

  render() {
    const { typeOption, editable, editPage } = this.props;
    const { roles } = this.state;
    return (
      <>
        <div className="account-id">
          <Form.Item
            wrapperCol={15}
            key={"employee_id"}
            label={`* Mã NV::`}
            name={"signup_name"}
            rules={[]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            wrapperCol={15}
            key={"roles"}
            label={`* Vai trò (Roles)::`}
            name={"roles"}
            rules={[
              {
                required: true,
                message: `Vui lòng chọn Vai trò!`,
              },
            ]}
          >
            {/* <Select
                        disabled={!editable}
                        placeholder="Chọn vai trò"
                        onChange={this.handleChange}
                    >
                        {children.map(item => <Option value={item.id}>{item.name}</Option>)}
                    </Select> */}
            <Dropdown
              disabled={!editable}
              select={(value) => this.setRole(value)}
              className="input"
              menu={roles}
              title="Chọn vai trò"
            />
          </Form.Item>
        </div>
      </>
    );
  }
}
